import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchText$ from '@atlassian/jira-fetch/src/utils/as-text-stream.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	baseUrl: string,
	customFieldId: number,
	rapidViewId: number,
	sprintId: number | null,
	issueKeys: string[],
	rankBeforeKey: string | null,
	rankAfterKey: string | null,
	addToBacklog: boolean,
): ObservableType<string | null> =>
	fetchText$(`${baseUrl}/rest/greenhopper/1.0/sprint/rank`, {
		method: 'PUT',
		body: JSON.stringify({
			addToBacklog,
			calculateNewIssuesOrder: false,
			customFieldId,
			idOrKeys: issueKeys,
			rapidViewId,
			sprintId,
			...(rankAfterKey ? { idOrKeyAfter: rankAfterKey } : {}),
			...(!rankAfterKey && rankBeforeKey ? { idOrKeyBefore: rankBeforeKey } : {}),
		}),
	});
